<div class="pinch-to-zoom">
    <img src="assets/images/pinch-icon.svg" alt="hand pinching fingers together" class="pinch-to-zoom__icon" />
    <span class="pinch-to-zoom__text">Pinch to zoom</span>
</div>
